








import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: "NameExhibition"
})
export default class NameExhibition extends Vue {
  @Prop({type: [String], default: ''}) protected title!: string

}
